import { useSetAtom } from 'jotai';
import { useMemo } from 'react';
import { scanTimeoutReducerAtom } from './atoms';
export function useScanTimeoutManager() {
  const dispatch = useSetAtom(scanTimeoutReducerAtom);
  return useMemo(() => ({
    clearAllScanTimeouts: callback => dispatch({
      callback,
      type: 'clear-all'
    }),
    clearPageScanTimeout: pageId => dispatch({
      pageId,
      type: 'clear'
    }),
    clearScanTimeoutsForItemType: itemType => dispatch({
      itemType,
      type: 'clear-all-item-type'
    }),
    initScanTimeouts: expiresAtMap => dispatch({
      expiresAtMap,
      type: 'init'
    }),
    setPageScanTimeout: pageId => dispatch({
      pageId,
      type: 'set'
    }),
    setScanTimeoutForItemType: itemType => dispatch({
      itemType,
      type: 'set-all-item-type'
    })
  }), [dispatch]);
}
//# sourceMappingURL=use-scan-timeout-manager.js.map